// extracted by mini-css-extract-plugin
export default {"Sentiment__container":"sentiment-styles__Sentiment__container__eLrpN","Sentiment__button":"sentiment-styles__Sentiment__button__KTfR5"};